module.exports = __webpack_public_path__ + "img/eligibilite1.3ea638c2.jpg";